import React from "react";
import { useTranslation } from "react-i18next";
import { MediaFileVM } from "../../../../types/viewModels/cmsPublic";

export interface NewsVideoProps {
  title: string;
  embedUrl: string;
  originalUrl: string;
  file: MediaFileVM | null;
}

const NewsVideo: React.FC<NewsVideoProps> = ({
  title,
  embedUrl,
  originalUrl,
  file,
}) => {
  const { t } = useTranslation("news");

  if (!embedUrl && !originalUrl && !file) {
    return null;
  }

  return (
    <section className="w-100 my-5">
      <h2 className="h4">{t("video")}</h2>
      <hr className="custom-divider" />

      {embedUrl && (
        <div className="ratio ratio-16x9 mb-3">
          <iframe
            src={embedUrl}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}

      {file && (
        <video className="w-100 mb-3" controls src={file.url}>
          {file.name}
        </video>
      )}

      {!embedUrl && originalUrl && (
        <a href={originalUrl} target="_blank" rel="noreferrer">
          {t("openVideo")}
        </a>
      )}
    </section>
  );
};

export default NewsVideo;
